export const fetchRegCodesList = async (token) => {
  const requestURL = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/regCodesList`
  );

  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });

  try {
    const data = await fetch(requestURL, {
      method: "GET",
      headers,
    });

    if (!data.ok) {
      throw {
        message: `RegCodes List Fetch Data Not Okay: ${data.status}`,
        code: data.status,
      };
    }

    const jsonData = await data.json();
    return jsonData;
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = "fetchRegCodesList";
    const errorCode = isInternalError ? 500 : error.errorCode;
    return { errorType, errorCode };
  }
};
